import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { TagTypeItemComponent } from './tag-type-item/tag-type-item.component';
import { TagTypesManagerComponent } from './tag-types-manager.component';

@NgModule({
    imports: [SharedModule],
    declarations: [
        TagTypeItemComponent,
        TagTypesManagerComponent
    ],
    entryComponents: [TagTypesManagerComponent],
    exports: [TagTypesManagerComponent]
})
export class TagTypesManagerModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/tag-types-manager/tag-types-manager.module.ts